export default {
  message: {
    "strid1": "الصفحة الرئيسية",
    "strid2": "شروحات تعليمية",
    "strid3": "الحدث",
    "strid4": "انضم إلينا",
    "strid5": "ديسكورد",
    "strid6": "أكاديمية منشئي المحتوى",
    "strid7": "اعمال محددة",
    "strid8": "عودة",
    "strid9": "اشترك الآن",
    "strid10": "المزيد من الأحداث",
    "strid11": "معلومات شخصية",
    "strid12": "سيرفر اللعبة",
    "strid13": "الرجاء إدخال السيرفر الخاص بك",
    "strid14": "رقم الهوية",
    "strid15": "الرجاء إدخال رقم الهوية الخاص بك",
    "strid16": "معلومات التواصل",
    "strid17": "اختر المنصة",
    "strid18": "الرجاء إدخال معلومات التواصل الخاصة بك",
    "strid19": "تفاصيل العمل",
    "strid20": "منصة النشر",
    "strid21": "الرجاء إدخال الرابط الصحيح",
    "strid22": "انقر لإضافة رابط جديد",
    "strid23": "اللغة المستخدمة",
    "strid24": "حدد اللغة المستخدمة",
    "strid25": "الإنجليزية",
    "strid26": "العربية",
    "strid27": "الإسبانية",
    "strid28": "البرتغالية",
    "strid29": "الخمير",
    "strid30": "البورمية",
    "strid31": "لغة الملايو",
    "strid32": "أخرى",
    "strid33": "أؤكد ملكية العمل وأعترف بهذه الاتفاقية",
    "strid34": "إرسال",
    "strid35": "تم الإرسال!",
    "strid36": "المزايا",
    "strid37": "انضم إلينا الآن لتحصل على",
    "strid38": "دعم من وسائل التواصل الإجتماعي الرسمية لموبايل ليجيندز",
    "strid39": "مجتمع تفاعلي للمبدعين",
    "strid40": "جوائز ألماس أسبوعية",
    "strid41": "المزيد من المزايا لفتحها",
    "strid42": "بضائع داخل اللعبة",
    "strid43": "أحداث دون الاتصال بالإنترنت",
    "strid44": "الكثير من المظاهر",
    "strid45": "التعاون مع علامات تجارية",
    "strid46": "ترويج الإعلانات",
    "strid47": "انضم إلينا",
    "strid48": "الشروط",
    "strid49": "تابعنا",
    "strid50": "إضغط لتفقد حساب موبايل ليجيندز الرسمي",
    "strid51": "محتوى الاتفاقية",
    "strid52": "يرجى إستكمال المعلومات",
    "strid53": "فشل الإرسال",
    "strid54": "يرجى ملء رابط قناتك",  // 请输入正确的频道链接
    "strid55": "قم باختيار منطقتك",
    "strid56": "منطقتك",


  }
}
